import { useState } from 'react';
import styled from 'styled-components';
import Modal from 'components/ui-components/Modal';
import Button from 'components/ui-components/Button';

import { useHTTP } from 'hooks/useRequest';
import { InfoIcon } from 'assets/icons';
import { grey30 } from 'constants/variables';
import toRem from 'utils/toRem';
import responsive from 'utils/responsive';

import OptInIcon from './ModalIcon';

const MFAOptInModal = () => {
  const [modalIsOpen, setModalIsOpen] = useState(true);

  const mfaModalDismissConfig = {
    method: 'POST',
    url: !modalIsOpen ? '/mfa/dismiss_modal' : null,
  };

  useHTTP(mfaModalDismissConfig || null);

  const closeModal = () => setModalIsOpen(false);

  const continueToOptIn = () => {
    closeModal();
    window.location.href = '/mycef/mobile_number/edit?mfa=true';
  };

  return (
    <StyledModal isOpen={modalIsOpen} closeModal={closeModal}>
      <StyledIcon />
      <p className="ff-body fs-24 m-fs-34 tc-main fw-600 lh-1-2 mb-24 m-mb-32 ta-c">
        Increase account security with two-factor authentication
      </p>
      <p className="ff-body fs-16 m-fs-18 tc-secondary lh-1-3 ta-c">
        Turn on two-factor authentication to add an extra layer of security to
        your account. We&apos;ll send you a verification code by text message
        each time you sign in.
      </p>
      <div className="fl fl-col jc-fe ai-c mt-32 m-mt-40 mb-32 m-mb-40">
        <Button
          type="button"
          handleClick={continueToOptIn}
          label="Get Started"
          className="cef-btn cef-btn--green cef-btn--feature cef-ui__button mb-24 width-100">
          Get Started
        </Button>
        <Button
          type="button"
          handleClick={closeModal}
          label="Dismiss"
          className="cef-btn--as-link fs-18 tc-secondary td-u">
          Dismiss
        </Button>
      </div>
      <div className="fl">
        <div>
          <InfoIcon width="14" height="14" fillColor={grey30} />
        </div>
        <p className="ff-body fs-12 m-fs-13 tc-secondary lh-1-4 ml-6 mb-0">
          You can manage your two-factor authentication settings at any time in{' '}
          <strong>Your Account</strong> &gt; <strong>Login & Security</strong>
        </p>
      </div>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  > div {
    padding: ${toRem(32)} ${toRem(24)};
    width: 80%;
    max-width: 575px;
    box-sizing: border-box;

    ${responsive('tabletSmall')} {
      padding: ${toRem(48)} ${toRem(64)};
    }
  }
`;

const StyledIcon = styled(OptInIcon)`
  display: block;
  margin: 0 auto;
  width: 125px;
  height: auto;
  margin-bottom: ${toRem(24)};

  ${responsive('tabletSmall')} {
    width: 182px;
    margin-bottom: ${toRem(32)};
  }
`;

export default MFAOptInModal;
